import { NodeAccessApproval, NodeAccessProfileStatus } from '@prisma/client';
import { Alert, Descriptions, Form, Result, Space } from 'antd';

import { ApprovalStage } from '@app/domain-t3-interfaces';

import { useUpdateProfileApproval } from '../data';
import { ApprovalFormData, getDescriptionItems, useApprovalForm } from '../libs';

export type ApprovalFormProps = {
  record: NodeAccessApproval;
  onCancel?: () => void;
};

export const ApprovalForm = ({ record, onCancel }: ApprovalFormProps) => {
  const approvalMutation = useUpdateProfileApproval(record.id);
  const { getFormProps, getSuccessResultProps } = useApprovalForm(
    approvalMutation,
    record.status !== NodeAccessProfileStatus.PENDING,
    onCancel,
  );
  const initialValues: ApprovalFormData = {
    justification: '',
  };

  return approvalMutation.isSuccess ? (
    <Result {...getSuccessResultProps()} />
  ) : (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Descriptions
        bordered
        size="small"
        layout="horizontal"
        labelStyle={{ width: 150 }}
        column={1}
        items={getDescriptionItems(record)}
      />
      {record.approvalStageName === ApprovalStage.EXTERNAL_TSMC && (
        <Alert
          message="This profile is in EXTERNAL_TSMC stage and might a part of the snapshot. Approving/Rejecting it will make the corresponding approval from external foundry redundant."
          type="warning"
          showIcon
        />
      )}
      <Form {...getFormProps()} initialValues={initialValues} />
    </Space>
  );
};
